import React from "react";
import Footer from "../../components/footer";
import PageAction from "../../components/page-action";
import PageHeader from "../../components/page-header";

const PageContent = ({ children, header, action }) => {
  return (
    <>
      {header ? (
        <div className="row wrapper border-bottom white-bg page-heading">
          <PageHeader titulo={header} />

          {action ? <PageAction action={action} /> : <></>}
        </div>
      ) : (
        <></>
      )}

      <div className="wrapper wrapper-content animated">{children}</div>
      <Footer />
    </>
  );
};

export default PageContent;
